import NotesViewModal from './NotesViewModal';

export default NotesViewModal;
export * from './NotesViewModal';
